import serviceRequest from "utils/request";

const baseUrl = "/api/qrCode";

export const getAttendanceQRCode = () => {
	return serviceRequest({
		url: `${baseUrl}/get-attendance-qrs`,
		method: "get",
	});
};
